import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getActionCompletedTime } from '../../utils/actionTiming';

import DetailsForm from '../../components/Email/DetailsForm';
import DetailsFormMultiRepStep1 from '../../components/Email/DetailsFormMultiRepStep1';

import { CardTypes, LocalRepState } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { copyFor } from '../../copy/copy';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import { TransitionGroup } from 'react-transition-group';
import CssTransition from '../../components/Transition/CssTransition';

import ToasterAlert from '../../components/Donation/ToasterAlert';

import WidgetHeader from '../Widget/WidgetHeader';
import RoundImage from '../../components/Image/RoundImage';

import defaultImage from '../../assets/images/localRepDefault.jpg';

import { onBackWithinCard, onGoToNextCard } from '../Widget/actions';
import { cacheFormData } from '../../utils/formCaching/actions';
import { onEmailComplete, onEmailMessageChange, continueToStep2 } from './actions';

import {
    onFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    onDeleteClick,
    onAddClick,
    onShowRepresentatives
} from '../LocalRep/actions';

import {
    SidebarTitle,
    SidebarDescription,
    NotYourRepInfo
} from '../DefaultStyles/Details';

import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';

import {
    Container,
    Body,
    Content,
    Sidebar,
    ContentContainer,
    FindRepLink,
    ImageContainer
} from '../DefaultStyles/Details';

const EmailDetails = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <TransitionGroup>
            {props.emailSubmitError && (
                <CssTransition key="alert" in={props.emailSubmitError}>
                    <ToasterAlert content={props.emailSubmitError} />
                </CssTransition>
            )}
        </TransitionGroup>
        <Body>
            <WidgetHeader />
            {props.isHouseRep ? (
                <Content>
                    <Sidebar>
                        <ImageContainer>
                            <RoundImage
                                src={
                                    (props.useLocalRepresentative
                                        ? props.image
                                        : props.pictureUrl || defaultImage) ||
                                    props.pictureUrl ||
                                    defaultImage
                                }
                            />
                        </ImageContainer>
                        <SidebarTitle>
                            {copyFor('sidebar', 'title', 'email', undefined, {
                                recipientName: props.recipientName
                            })}
                        </SidebarTitle>
                        {props.localRepFound && props.useLocalRepresentative ? (
                            <NotYourRepInfo
                                isUnderImage={true}
                                isLocalRepLoading={props.isLocalRepLoading}
                            >
                                {copyFor('findReps', 'notYour', 'email')} <br />
                                <FindRepLink onClick={props.onFindYourRep}>
                                    {copyFor('findReps', 'clickToFind', 'email')}
                                </FindRepLink>
                            </NotYourRepInfo>
                        ) : (
                            <SidebarDescription>
                                {copyFor('sidebar', 'description', 'email')}
                            </SidebarDescription>
                        )}
                    </Sidebar>
                    <ContentContainer>
                        <DetailsForm
                            onSubmit={values => {
                                props.cacheFormData(values);
                                if (props.skipEndCard) {
                                    props.handleSkippingEndCard(
                                        props.nextAction,
                                        props.cards,
                                        props.onGoToNextCard
                                    );
                                }
                                props.onEmailComplete(
                                    props.apiRequestData,
                                    props.actionCompletedTime(),
                                    values,
                                    props.localRepData,
                                    props.isMultiActionsCard,
                                    props.actionIdentifier,
                                    props.thankYouText,
                                    props.thankYouTitle,
                                    props.useLocalRepresentative,
                                    props.recipientMask,
                                    props.repFullName,
                                    props.actionType,
                                    '',
                                    '',
                                    props.localRepresentativeState,
                                    [],
                                    props.skipEndCard
                                );
                            }}
                            response={props.response}
                            onBackFromRepAction={() =>
                                props.onBackWithinCard(props.actionIdentifier, props.card)
                            }
                            isSubmitting={props.isSubmitting}
                            onFocus={onFocus(props.isMobileResolution)}
                            isEmailMessageChanged={props.isEmailMessageChanged}
                            onEmailMessageChange={props.onEmailMessageChange}
                        />
                    </ContentContainer>
                </Content>
            ) : (
                <Content>
                    <ContentContainer>
                        {props.localRepFound && props.useLocalRepresentative && (
                            <NotYourRepInfo
                                isLocalRepLoading={props.isLocalRepLoading}
                                id="notYourRepInfo"
                            >
                                <FindRepLink onClick={props.onFindYourRep}>
                                    {copyFor('findReps', 'notYour', 'email')}
                                </FindRepLink>
                            </NotYourRepInfo>
                        )}
                        <DetailsFormMultiRepStep1
                            onSubmit={values => {
                                props.cacheFormData(values, props.actionIdentifier);
                                props.continueToStep2(values);
                            }}
                            onBackFromRepAction={() =>
                                props.onBackWithinCard(props.actionIdentifier, props.card)
                            }
                            onDeleteClick={data => props.onDeleteClick(data)}
                            onAddClick={data => props.onAddClick(data)}
                            onShowRepresentatives={() => props.onShowRepresentatives()}
                            isSubmitting={props.isSubmitting}
                            onFocus={onFocus(props.isMobileResolution, true)}
                            isEmailMessageChanged={props.isEmailMessageChanged}
                            onEmailMessageChange={props.onEmailMessageChange}
                            activeAction={props.activeAction}
                        />
                    </ContentContainer>
                </Content>
            )}
        </Body>
        {props.localRepFound && props.useLocalRepresentative && (
            <TransitionGroup>
                {props.showFindYouRepPopup && (
                    <CssTransition key="alert" in={props.showFindYouRepPopup}>
                        <FindLocalRepPopup
                            hideFindRepPopup={props.hideFindRepPopup}
                            onSubmit={data =>
                                props.loadLocalRep(data, true, props.showOnlySenators)
                            }
                        />
                    </CssTransition>
                )}
            </TransitionGroup>
        )}
    </Container>
);

const onFocus = (isMobileResolution, isMultiRep) => {
    if (!isMobileResolution) {
        setTimeout(() => {
            var textarea = document.getElementById('textarea');
            if (textarea) {
                textarea.addEventListener(
                    'focus',
                    function(event) {
                        document
                            .querySelectorAll('.row-wrapper-1')[0]
                            .classList.add('focused');
                        document
                            .querySelectorAll('.row-wrapper-2')[0]
                            .classList.add('focused');
                        document
                            .querySelectorAll('.row-wrapper-3')[0]
                            .classList.add('focused');

                        if (isMultiRep) {
                            document
                                .getElementById('notYourRepInfo')
                                .classList.add('focused');
                        }
                    },
                    true
                );

                textarea.addEventListener(
                    'blur',
                    function() {
                        document
                            .querySelectorAll('.row-wrapper-1')[0]
                            .classList.remove('focused');
                        document
                            .querySelectorAll('.row-wrapper-2')[0]
                            .classList.remove('focused');
                        document
                            .querySelectorAll('.row-wrapper-3')[0]
                            .classList.remove('focused');

                        if (isMultiRep) {
                            document
                                .getElementById('notYourRepInfo')
                                .classList.remove('focused');
                        }
                    },
                    true
                );
            }
        }, 50);
    }
};

EmailDetails.propTypes = {
    nextAction: PropTypes.object,
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    image: PropTypes.string,
    isEmailMessageChanged: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    isSubmitting: PropTypes.bool.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    onEmailComplete: PropTypes.func.isRequired,
    onEmailMessageChange: PropTypes.func.isRequired,
    pictureUrl: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    recipientName: PropTypes.string,
    card: PropTypes.object.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    recipientMask: PropTypes.string,
    repFullName: PropTypes.string,
    isHouseRep: PropTypes.bool.isRequired,
    actionType: PropTypes.number.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    isLocalRepLoading: PropTypes.bool,
    onFindYourRep: PropTypes.func.isRequired,
    showFindYouRepPopup: PropTypes.bool.isRequired,
    hideFindRepPopup: PropTypes.func.isRequired,
    loadLocalRep: PropTypes.func.isRequired,
    continueToStep2: PropTypes.func.isRequired,
    localRepresentativeState: PropTypes.number,
    showOnlySenators: PropTypes.bool.isRequired,
    emailSubmitError: PropTypes.string,
    activeAction: PropTypes.object,
    cards: PropTypes.array.isRequired,
    skipEndCard: PropTypes.bool,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    localRepData: PropTypes.object,
    response: PropTypes.string,
    onDeleteClick: PropTypes.func.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onShowRepresentatives: PropTypes.func.isRequired
};

const pictureUrl = state => {
    const picture = state.widget.pictures.find(
        a => a.recipientPictureId === state.widget.activeAction.recipientPictureId
    );
    return (picture || {}).pictureUrl;
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            nextAction,
            actionCompletedTime: getActionCompletedTime(state, 'email'),
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            image: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative[0].photoUrl
                : '',
            isEmailMessageChanged: state.email.isEmailMessageChanged,
            isMobileResolution: state.widget.isMobileResolution,
            isSubmitting: state.email.isSubmitting,
            localRepData: state.localRep.localRepData,
            response: state.widget.activeAction.text,
            pictureUrl: pictureUrl(state),
            useLocalRepresentative:
                state.widget.activeAction.localRepresentativeState !==
                LocalRepState.disabled,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            cards: state.widget.cards,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            recipientName:
                state.widget.activeAction.localRepresentativeState !==
                LocalRepState.disabled
                    ? state.localRep.localRepData.representative[0].shortName
                    : state.widget.activeAction.recipientMask,
            thankYouText: state.widget.activeAction.thankYouText || '',
            thankYouTitle: state.widget.activeAction.thankYouTitle,
            recipientMask: state.widget.activeAction.recipientMask,
            repFullName: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative[0].fullName
                : '',
            isHouseRep:
                state.widget.activeAction.localRepresentativeState !==
                    LocalRepState.all &&
                state.widget.activeAction.localRepresentativeState !==
                    LocalRepState.senators,
            actionType: state.widget.activeAction.localRepresentativeState,
            localRepFound: state.localRep.localRepData.representative !== undefined,
            isLocalRepLoading: state.localRep.isLocalRepLoading,
            showFindYouRepPopup: state.localRep.showFindYouRepPopup,
            localRepresentativeState: state.widget.activeAction.localRepresentativeState,
            showOnlySenators:
                state.widget.activeAction.localRepresentativeState ===
                LocalRepState.senators,
            emailSubmitError: state.email.emailSubmitError
                ? state.email.emailSubmitError.message || state.email.emailSubmitError
                : state.email.emailSubmitError,
            activeAction: state.widget.activeAction,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        onBackWithinCard,
        onEmailComplete,
        onEmailMessageChange,
        onFindYourRep,
        hideFindRepPopup,
        loadLocalRep,
        continueToStep2,
        onDeleteClick,
        onAddClick,
        onShowRepresentatives,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData
    }
)(EmailDetails);



// WEBPACK FOOTER //
// ./src/containers/Email/EmailDetails.jsx